import {Model} from "../decorators/model.decorator";
import {Column} from "../decorators/column.decorator";
import {BaseModel} from "./base.model";

@Model('categoryTokens')
export class CategoryToken extends BaseModel {
  @Column()
  id: number | undefined;
  @Column()
  value: string | undefined;
  @Column()
  iso: string | undefined;
}
